// src/services/categoryService.js

import API from "../services/base_url";
import { getToken } from "../utils/auth";

export const registerUser = async (data) => {
  try {
    const response = await API.post(`/welfare/welfare-system/register`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    console.error("Registration error:", error);
    let message = "Something went wrong during registration";
    if (error.response?.data?.error) {
      message = error.response.data.error;
    } else if (error.message) {
      message = error.message;
    }
    return { success: false, error: message };
  }
};


export const loginUser = async (email, password) => {
  try {
    const res = await API.post(
      "/welfare/welfare-system/login",
      {
        email: email,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );

    console.log("Login API Response:", res.data);

    // ✅ Return the data directly - it already has { status, token, user }
    return res.data;
  } catch (err) {
    console.error("Login Error:", err);
    
    // ✅ Return error in same format as backend
    if (err.response) {
      return { 
        status: false, 
        message: err.response.data?.message || "Login failed. Please check credentials." 
      };
    }
    
    return { 
      status: false, 
      message: "Network error - please check your connection" 
    };
  }
};



//add contribution

// export const addContribution = async (userId, amount, category) => {
//   try {
//     const token = getToken();
//     const response = await API.post(
//       `/welfare/welfare-system/add-contribution?user_id=${userId}`,
//       {
//         amount,
//         category,
//       },
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     return response.data;
//   } catch (err) {
//     console.log("Add contribution failed:", err.response || err);
//     throw err;
//   }
// };

export const getContributions = async (userId, token) => {
  try {
    const res = await API.get(
      `/welfare/welfare-system/get-contributions?user_id=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.status === 200 && res.data.status) {
      return { success: true, data: res.data.data };
    } else {
      return { success: false, error: res.data.message || "No records found." };
    }
  } catch (err) {
    console.log("Get contributions failed:", err);
    return { success: false, error: "Error loading contributions." };
  }
};

// api/userApi.js
export const updateUserProfile = async (data, user_id, token) => {
  try {
    const response = await API.post(
      `/welfare/welfare-system/update-profile?user_id=${user_id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    console.error("Update error:", error);
    let message = "Something went wrong during profile update";
    if (error.response?.data?.error) {
      message = error.response.data.error;
    } else if (error.message) {
      message = error.message;
    }
    return { success: false, error: message };
  }
};

// hooks/api.js

export const sendResetPasswordEmail = async (email) => {
  try {
    const response = await fetch(
      "https://aceswafund.org/welfare/welfare-system/forgot-password",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      }
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (err) {
    return { error: "Network error" };
  }
};

export const fetchCategories = async () => {
  try {
    // Retrieve token (e.g. from localStorage)

    const response = await API.get("categories");

    if (response.status === 200) {
      return { data: response.data.categories || [], error: null };
    } else {
      throw new Error("Unexpected response");
    }
  } catch (err) {
    return { data: [], error: err.message || "Failed to fetch categories" };
  }
};

export const fetchSliders = async () => {
  try {
    const response = await API.get("sliders");

    if (response.status === 200) {
      return { data: response.data.sliders || [], error: null };
    } else {
      throw new Error("Unexpected response");
    }
  } catch (err) {
    return { data: [], error: err.message || "Failed to fetch sliders" };
  }
};

export const fetchFeaturedProducts = async () => {
  try {
    const response = await API.get("features");

    if (response.status === 200) {
      return { data: response.data.featured || [], error: null };
    } else {
      throw new Error("Unexpected response");
    }
  } catch (err) {
    return {
      data: [],
      error: err.message || "Failed to fetch featured products",
    };
  }
};

export const fetchProductById = async (id) => {
  try {
    const response = await API.get(`product/${id}`);

    if (response.status === 200) {
      return { data: response.data, error: null };
    } else {
      return { data: null, error: "Unexpected response" };
    }
  } catch (error) {
    return {
      data: null,
      error: error?.response?.data?.error || "Failed to fetch product",
    };
  }
};
//fetch admin stats
export const fetchAdminStats = async (token) => {
  try {
    const res = await API.get("/welfare/welfare-system/admin/admin-stats", {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log("DATA " + res.data);
    return { data: res.data, error: null };
  } catch (err) {
    const errorMsg =
      err.response?.data?.error || err.response?.data?.message || err.message;
    return { data: null, error: errorMsg };
  }
};
//fetch summary
export async function fetchSalesSummary() {
  try {
    const res = await API.get("/welfare/welfare-system/admin/sales-summary");

    return { data: res.data, error: null };
  } catch (err) {
    const errorMsg =
      err.response?.data?.error || err.response?.data?.message || err.message;
    return { data: null, error: errorMsg };
  }
}

// In your hooks/api.js file https://aceswafund.org/welfare/welfare-system/get-profile?user_id=1
export const getUserProfile = async (userId, token) => {
  try {
    const response = await fetch(
      `https://www.aceswafund.org/welfare/welfare-system/get-profile?user_id=${userId}`,
      {
        method: 'GET', // Explicitly set GET method
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log("Profile API response:", data); // Debug log
    return data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    return { status: false, error: error.message };
  }
};

// In your hooks/api.js
// In your hooks/api.js
export const updateProfileImage = async (userId, token, imageFile) => {
  try {
    const formData = new FormData();
    formData.append('profile_image', imageFile);
    
    // YOUR PHP EXPECTS userId IN THE URL PARAMETER
    const response = await fetch(
      `https://www.aceswafund.org/welfare/welfare-system/update-profile-image/${userId}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          // Don't set Content-Type header - browser will set it with boundary
        },
        body: formData,
      }
    );

    const data = await response.json();
    console.log("API Response:", data); // Debug log
    return data;
  } catch (error) {
    console.error("Error updating profile image:", error);
    return { status: false, error: error.message };
  }
};